// src/pages/SupportChats.js
import React, { useEffect, useState, useRef } from 'react';
import Sidebar from '../components/Sidebar';
import ChatsDisplay from '../components/ChatsDisplay';
import FloatingChatWindow from '../components/ChatWindow';
import pingSound from '../assets/audio/ping.mp3';

const SupportChats = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [openChats, setOpenChats] = useState([]);
  const [chats, setChats] = useState([]);

  const chatsRef = useRef([]);
  const openChatsRef = useRef([]);
  const audioRef = useRef(new Audio(pingSound));
//adding comment to indicate this is a good change
  useEffect(() => {
    chatsRef.current = chats;
  }, [chats]);

  useEffect(() => {
    openChatsRef.current = openChats;
  }, [openChats]);

  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const handleMarkChatAsRead = (chatId) => {
    const event = new CustomEvent('chat-read', { detail: { chatId } });
    window.dispatchEvent(event);
  };

  const handleChatClick = (chat) => {
    if (!openChats.find(c => c.id === chat.id)) {
      setOpenChats(prev => [...prev, { ...chat, isMinimized: false }]);
    }
  };

  const handleToggleMinimized = (chatId) => {
    setOpenChats(prev =>
      prev.map(chat =>
        chat.id === chatId ? { ...chat, isMinimized: !chat.isMinimized } : chat
      )
    );
  };

  const handleCloseChat = (chatId) => {
    setOpenChats(prev => prev.filter(chat => chat.id !== chatId));
  };

  const updateChatInList = (chatId, message) => {
    setChats(prev => {
      const updated = [...prev];
      const idx = updated.findIndex(c => c.id === chatId);
      if (idx !== -1) {
        updated[idx] = {
          ...updated[idx],
          messages: [...(updated[idx].messages || []), message],
          responded: false,
          seen: false,
          updatedAt: new Date().toISOString(),
        };
      }
      return updated;
    });

    setOpenChats(prev =>
      prev.map(chat =>
        chat.id === chatId
          ? { ...chat, messages: [...(chat.messages || []), message] }
          : chat
      )
    );
  };

  useEffect(() => {
    const handleIncoming = ({ detail: { chatId, message } }) => {
      console.log(`📨 [SupportChats] chat-message event received for chat-${chatId}`);

      updateChatInList(chatId, message);

      const isOpen = openChatsRef.current.some(c => c.id === chatId);
      const foundChat = chatsRef.current.find(c => c.id === chatId);

      if (!isOpen && foundChat) {
        setOpenChats(prev => [...prev, { ...foundChat, isMinimized: false }]);
      } else if (isOpen) {
        setOpenChats(prev =>
          prev.map(chat =>
            chat.id === chatId ? { ...chat, isMinimized: false } : chat
          )
        );
      }

      try {
        const sound = audioRef.current;
        sound.pause();
        sound.currentTime = 0;
        sound.play();
      } catch (err) {
        console.warn('🔇 Could not play audio:', err);
      }
    };

    window.addEventListener('chat-message', handleIncoming);
    return () => window.removeEventListener('chat-message', handleIncoming);
  }, []);

  return (
    <div className="d-flex w-100 overflow-hidden">
      <div className="asidebar">
        <Sidebar />
      </div>
      <div className="main-content position-relative">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h2>All Support Chats</h2>
          <div className="d-flex align-items-center justify-content-end">
            <input
              type="text"
              className="form-control w-300px rounded-50 ps-3"
              style={{ height: '50px' }}
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
        </div>

        <ChatsDisplay
          searchQuery={searchQuery}
          onChatClick={handleChatClick}
          chats={chats}
          setChats={setChats}
          onChatRead={handleMarkChatAsRead}
        />

        {openChats.map((chat, index) => (
          <FloatingChatWindow
            key={chat.id}
            chat={chat}
            index={index}
            onClose={handleCloseChat}
            isMinimized={chat.isMinimized}
            toggleMinimized={handleToggleMinimized}
            onMessageSent={updateChatInList}
          />
        ))}
      </div>
    </div>
  );
};

export default SupportChats;
